import DSSOtherMedication from 'dashboard/templates/views/DSS/DSSOtherMedication';

export default {
  path: 'other-medication',
  name: 'DSSOtherMedication',
  component: DSSOtherMedication,
  meta: {
    // title: 'MDSS - Other Medication',
    title: t => `MDSS - ${t('myWeekMedication.otherMedication', 'app_mobile')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
